import { useContext, createContext } from "react";

export type Theme = 'dark' | 'light';
export type Density = 'compact' | 'normal' | 'comfortable';

export type AppContextType = {
  isAuthenticated: boolean;
  userHasAuthenticated: (next: boolean) => void;
  theme: Theme;
  setTheme: (next: Theme) => void;
  density: Density;
  setDensity: (next: Density) => void;
  savingsTarget: number;
  setSavingsTarget: (next: number) => void;
};

export const AppContext = createContext<AppContextType | undefined>(undefined);

export function useAppContext() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("AppContext not provided");
  return ctx;
}
